import {
  Component,
  Host,
  h,
  Prop,
  Watch,
  Element,
  Fragment,
} from '@stencil/core';
import store from '../../global/store';
import { BankSearchService } from '../../services/bank-search-service';

@Component({
  tag: 'ui-bank-search-light',
  styleUrl: 'ui-bank-search-light.scss',
  shadow: false, // careful: 'false' is necessary for uiInputClear -> removeSearchValues to work!
})
export class UiBankSearchLight {
  @Element() el;

  // 📢 If these props change, remember to also update them in ui-bank-search.tsx

  // Magnolia _could_ provide a URL, but currently doesn't.
  // The same URL is used for local dev, TEST, and PROD.
  @Prop() bankSearchApi =
    'https://filialfinder.union-investment.de/api/addressSearch';

  // Magnolia _will_ provide a different key for PRODUCTION. This key is for dev.
  @Prop() googleApiKey = 'AIzaSyAjA94yU4pD8rV1NYAx4nLw27lSCL14UKQ';

  @Prop() assetsUrl = './assets';

  @Watch('assetsUrl')
  onAssetsUrlChange() {
    store.state.assetsUrl = this.assetsUrl;
  }

  async componentWillLoad() {
    this.onAssetsUrlChange();

    BankSearchService.init(this.el, this.bankSearchApi, this.googleApiKey);
  }

  render() {
    return (
      <Host>
        <ui-cms-image
          altText=""
          src={`${store.state.assetsUrl}/bank-search-light-header.png`}
        ></ui-cms-image>
        <ui-bank-search-autocomplete></ui-bank-search-autocomplete>
        {store.state.resultsTotal?.length > 0 && (
          <Fragment>
            <h3 class="sd-headline sd-headline--size-lg results-title">
              {(window as any).ui.services?.i18n?.translate('bankSearch')
                .searchResults || 'Ihre Suchergebnisse'}
            </h3>
            <ui-bank-search-list mode="light"></ui-bank-search-list>
          </Fragment>
        )}
        {store.state.resultsTotal?.length > store.state.resultsVisibleCount && (
          <sd-button onClick={store.state.loadMore} variant="secondary">
            {(window as any).ui.services?.i18n?.translate('bankSearch')
              .showMoreResults || 'Mehr anzeigen'}
          </sd-button>
        )}
      </Host>
    );
  }
}
